import { AccesosEffects } from './accesos.effects';
import { AuthEffects } from './auth.effects';
import { MenuEffects } from './menu.effects';
import { OficinasEffects } from './oficinas.effects';

export const EffectsArray: any[] = [OficinasEffects, AccesosEffects, MenuEffects, AuthEffects];
